export const COLUMN_NAMES = {
    ID: 'id',
    PARAM: 'param',
    FOR_ROLE_TEXT_ID: 'forRoleTextId',
    STATUS: 'status',
    ACTIONS: 'actions',
};
